import React from 'react';
import ComboBox from '../../../../components/ComboBox';
import SelectUserComboBox from '../../../../components/SelectUserComboBox';
import dataModel from '../../../../models/DataModel';
import CollectionDataSource from '../../../../dao/DataSource/CollectionDataSource';
import FilterTags from '../../../../components/FilterTags';
import ReportDatePicker from '../../../ManagerDashboard/ReportDatePicker';
import DateUtil from '../../../../helpers/DateUtil/DateUtil';

import caret from '../../../../assets/images/caret.svg';
import anime from 'animejs';

import './CloseoutReportFilters.scss';

import BaseComponent from '../../../../baseClasses/BaseComponent';

export default class CloseoutReportFilters extends BaseComponent {
  constructor(props){
    super(props);
    
    const { statuses, project_types, project_managers, startDate, endDate, closeout_users, types } = props.selectedFilters;
    this.state = {
      selectedTypes: types || null,
      selectedStatuses: statuses || null,
      selectedProjectTypes: project_types || null,
      selectedProjectManagers: project_managers || null,
      selectedCloseoutUsers: closeout_users || null,
      startDate,
      endDate,
    };

    this.statusList = [
      { type: 'all', name: '-- All Status --', all: true },
      { type: '0', name: 'Completed' },
      { type: '1', name: 'In Progress' },
      { type: ['2','3','4','5'], name: 'Not Started' },
    ];

    this.typeList = [
      { type: 'all', name: '-- All Types --', all: true },
      { type: 'Build', name: 'Build' },
      { type: 'Project', name: 'Project' },
      { type: 'Task', name: 'Task' },
    ];
  }

  handleProjectTypesRetrieval(projectTypes) {
    this.setState({ projectTypes });
  }

  componentDidMount() {
    dataModel.usersDAO.getProjectManagers(this.props.markets).then(projectManagers => {
      if (projectManagers && this.projectTypesDataSource) {
        projectManagers.unshift({ id: -1, all: true, first_name: '-- All Project Managers --', last_name: '', multiSelect: true });
        this.setState({ projectManagers: projectManagers });
      }
    });

    dataModel.usersDAO.getAllUsers(this.props.markets)
    .then(closeoutUsers => {
      if (closeoutUsers && this.projectTypesDataSource) {
        const closeoutUserProperties = closeoutUsers.map((user) => {
          return {
            id: user.attributes.id,
            first_name: user.attributes.first_name,
            last_name: user.attributes.last_name,
            name: user.attributes.name,
          };
        });
        closeoutUserProperties.unshift({ id: -1, all: true, first_name: '-- All Users --', last_name: '', multiSelect: true });
        this.setState({ closeoutUsers: closeoutUserProperties });
      }
    });

    this.projectTypesDataSource = new CollectionDataSource('ProjectTypesCollection', 'ProjectType', { project_type: {} },
      this.handleProjectTypesRetrieval, 'CloseoutReportFiltersProjectTypes', null, localStorage.current_company_id);
    this.projectTypesDataSource.current();

  }

  componentWillUnmount() {
    if (this.projectTypesDataSource) {
      this.projectTypesDataSource.release();
      this.projectTypesDataSource = null;
    }
  }

  handleClickOutside(event) {
    if (this.reportDatePicker && !this.reportDatePicker.contains(event.target) && !event.target.className.includes('react-datepicker')) {
      this.handleDateDisplay();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedFilters != this.props.selectedFilters && this.props.selectedFilters) {
      this.setState({
        selectedTypes: this.props.selectedFilters && this.props.selectedFilters.types ? this.props.selectedFilters.types : null,
        selectedStatuses: this.props.selectedFilters && this.props.selectedFilters.statuses ? this.props.selectedFilters.statuses : null,
        selectedProjectTypes: this.props.selectedFilters && this.props.selectedFilters.project_types ? this.props.selectedFilters.project_types : null,
        selectedProjectManagers: this.props.selectedFilters && this.props.selectedFilters.project_managers ? this.props.selectedFilters.project_managers : null,
        selectedCloseoutUsers: this.props.selectedFilters && this.props.selectedFilters.closeout_users ? this.props.selectedFilters.closeout_users : null,
      });
    }
  }
  
  handleCloseMenu(){
    if (this.state.menu){
      this.setState({ menu: null, displayMenu: '' });
    }
  }

  handleProjectTypeFilterRemoved(filtersRemoved) {
    const { selectedProjectTypes } = this.state;
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };  
    selectedFilters.project_types = selectedProjectTypes.filter((projectType) => {
      return !filtersRemoved.find((typeRemoved) => {
        return typeRemoved.id == projectType.id;
      });
    });
    handleFilterChange(selectedFilters);
  }

  handleProjectManagerFilterRemoved(filtersRemoved) {
    let { selectedProjectManagers } = this.state;
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.project_managers = selectedProjectManagers.filter((projectManager) => {
      return !filtersRemoved.find((projectManagerRemoved) => {
        return projectManagerRemoved.id == projectManager.id;
      });
    });
    if (selectedFilters.project_managers.length == 0) {
      selectedFilters.project_managers = null;
    }
    handleFilterChange(selectedFilters);
  }

  handleCloseoutUserFilterRemoved(filtersRemoved) {
    let { selectedCloseoutUsers } = this.state;
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.closeout_users = selectedCloseoutUsers.filter((closeoutUser) => {
      return !filtersRemoved.find((closeoutUserRemoved) => {
        return closeoutUserRemoved.id == closeoutUser.id;
      });
    });
    if (selectedFilters.closeout_users.length == 0) {
      selectedFilters.closeout_users = null;
    }
    handleFilterChange(selectedFilters);
  }

  handleStatusFilterRemoved(statusesRemoved) {
    const { selectedStatuses } = this.state;
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.statuses = selectedStatuses.filter((status) => {
      const removed = statusesRemoved.find((statusRemoved) => {
        return statusRemoved.type == status;
      });
      return !removed;
    });
    handleFilterChange(selectedFilters);
  }

  handleTypeFilterRemoved(typesRemoved) {
    const { selectedTypes } = this.state;
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.types = selectedTypes.filter((type) => {
      const removed = typesRemoved.find((typeRemoved) => {
        return typeRemoved.type == type;
      });
      return !removed;
    });
    handleFilterChange(selectedFilters);
  }

  handleDateFilterRemoved(dateFilters) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.startDate = this.state.startDate;
    selectedFilters.endDate = this.state.endDate;
    for (const dateFilter of dateFilters) {
      if (dateFilter.type == 'start') {
        selectedFilters.startDate = null;
      } else {
        selectedFilters.endDate = null; 
      }
    }
    this.setState({ startDate: selectedFilters.startDate, endDate: selectedFilters.endDate });
    handleFilterChange(selectedFilters);
  }

  handleProjectTypeChange(multipleSelections) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    this.setState({ selectedProjectTypes: multipleSelections });
    selectedFilters.project_types = multipleSelections.map(ms => { return ms.project_type; });
    handleFilterChange(selectedFilters);
  }

  handleProjectManagerSelection(multipleSelections) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    this.setState({ selectedProjectManagers: multipleSelections });
    selectedFilters.project_managers = multipleSelections.length ? multipleSelections : null;
    handleFilterChange(selectedFilters);
  }

  handleCloseoutUserSelection(multipleSelections) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    this.setState({ selectedCloseoutUsers: multipleSelections });
    selectedFilters.closeout_users = multipleSelections.length ? multipleSelections : null;
    handleFilterChange(selectedFilters);
  }
  
  handleStatusChange(multipleSelections) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    this.setState({ selectedStatuses: multipleSelections });
    selectedFilters.statuses = multipleSelections.map(ms => { return ms.type; });
    handleFilterChange(selectedFilters);
  }

  handleTypeChange(multipleSelections) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    this.setState({ selectedTypes: multipleSelections });
    selectedFilters.types = multipleSelections.map(mt => { return mt.type; });
    handleFilterChange(selectedFilters);
  }

  handleDateSelection(date, type) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    if (type == 'start') {
      selectedFilters.startDate = date;
      this.setState({ startDate: date });
    } else {
      selectedFilters.endDate = date;
      this.setState({ endDate: date });
    }
    handleFilterChange(selectedFilters);
  }

  handleSetDatePickerRef(element) {
    this.datePicker = element;
  }
  
  async handleDateDisplay() {
    let { filterActive } = this.state;
    await this.setState({ 
      datePickerLeft: this.projectFilterContainer.getBoundingClientRect().left,
      datePickerTop: this.projectFilterContainer.getBoundingClientRect().bottom,
    });
    if (!filterActive) {
      document.addEventListener('click', this.handleClickOutside, false);
      await anime({
        targets: '.ReportDatePicker',
        height: 108,
        easing: 'easeInOutCubic',
        duration: 200,
        begin: () => {
          this.setState({ filterActive: true });
        },
        update: (anim) => {
          if (anim.progress > 50) {
            this.datePicker.style.display = 'flex';
          }
        },
        complete: () => {
          document.querySelector('.ReportDatePicker').style.overflow = 'initial';
        },
      });
    }
    else {
      document.removeEventListener('click', this.handleClickOutside, false);
      await anime({
        targets: '.ReportDatePicker',
        height: 0,
        easing: 'easeInOutCubic',
        duration: 200,
        begin: () => {
          document.querySelector('.ReportDatePicker').style.overflow = 'hidden';
        },
        complete: () => {
          this.setState({ filterActive: false });
        },
        update: (anim) => {
          if (anim.progress > 50) {
            this.datePicker.style.display = 'none';
          }
        },
      });
    }
  }

  createTimeDisplay() {
    let timeDisplay = '';
    if (!this.state.startDate && !this.state.endDate) {
      timeDisplay = '-- All Time --';
      return timeDisplay;
    }
    
    if (this.state.startDate) {
      timeDisplay += DateUtil.formatDateFromDash(this.state.startDate);
    }
    else if (!this.state.startDate) {
      timeDisplay += 'All';
    }
    if (this.state.endDate) {
      timeDisplay = timeDisplay + ' - ' + DateUtil.formatDateFromDash(this.state.endDate);
    }
    else if (!this.state.endDate) {
      timeDisplay += ' - All';
    }
    return timeDisplay;
  }

  render(){
    let { selectedStatuses, selectedProjectTypes, selectedProjectManagers, selectedTypes, selectedCloseoutUsers } = this.state;
    const { isVertical, altClassName } = this.props;

    let selectedStatusTags = [];
    let statuses = this.statusList.map(status => {
      let selected = false;
      if (selectedStatuses) {
        let foundType = selectedStatuses.find(sta => {
          return sta.type ? sta.type == status.type : sta == status.type;
        });
        selected = foundType != undefined;
      }
      
      status.selected = selected;
      if (selected) {
        selectedStatusTags.push(status);
      }
      return status;
    });
    
    let statusSelector = null;
    if (!this.props.dontIncludeStatus) {
      statusSelector = <div className={'closeout-filter-container closeout-filter-container__closeout-statuses'}>
        <div className='closeout-filter-selector-label'>
          {'CLOSEOUTS STATUS'}
        </div>
        <div className='closeout-filter-selector-container'>
          <ComboBox id={'statusPicker'} options={statuses}
            hasBorder={false} underlined={false}
            multiSelect={true}
            height={32}
            width={isVertical ? 304 : 140}
            displayFontStyle={{ fontSize: '12px' }}
            handleMultiMenuSelection={this.handleStatusChange}
            placeHolderText="Project Status" />
        </div>      <div className='closeout-filter-selector-filtertags'>
          <FilterTags filters={selectedStatusTags} handleFilterRemoved={this.handleStatusFilterRemoved} isDashboard={this.props.isDashboard} />
        </div>
      </div>;
    }

    let selectedTypeTags = [];
    let types = this.typeList.map(type => {
      let selected = false;
      if (selectedTypes) {
        let foundType = selectedTypes.find(ty => {
          return ty.type ? ty.type == type.type : ty == type.type;
        });
        selected = foundType != undefined;
      }
      
      type.selected = selected;
      if (selected) {
        selectedTypeTags.push(type);
      }
      return type;
    });
    
    let typeSelector = null;
    if (!this.props.dontIncludeType) {
      typeSelector = <div className={'closeout-filter-container closeout-filter-container__closeout-types'}>
        <div className='closeout-filter-selector-label'>
          {'CLOSEOUTS TYPES'}
        </div>
        <div className='closeout-filter-selector-container'>
          <ComboBox id={'typePicker'} options={types}
            hasBorder={false} underlined={false}
            multiSelect={true}
            height={32}
            width={isVertical ? 230 : 135}
            displayFontStyle={{ fontSize: '12px' }}
            handleMultiMenuSelection={this.handleTypeChange}
            placeHolderText="Project Type" />
        </div>      <div className='closeout-filter-selector-filtertags'>
          <FilterTags filters={selectedTypeTags} handleFilterRemoved={this.handleTypeFilterRemoved} isDashboard={this.props.isDashboard} />
        </div>
      </div>;
    }

    let dateFilterTags = [];
    if (this.state.startDate) {
      dateFilterTags.push({ type: 'start', name: 'FROM: ' + DateUtil.formatDateFromDash(this.state.startDate) });
    }
    if (this.state.endDate) {
      dateFilterTags.push({ type: 'end', name: 'TO: ' + DateUtil.formatDateFromDash(this.state.endDate) });
    }
    
    let project_typesList = [];
    if (this.state.projectTypes && this.state.projectTypes.length > 0) {
      project_typesList = this.state.projectTypes.map(project_type => {
        let selected = false;
        if (selectedProjectTypes) {
          let foundType = selectedProjectTypes.find(pt => {
            if (pt.project_type) {
              return pt.project_type.id == project_type.id;
            }
            else {
              return pt.id == project_type.id;
            }
          });
          selected = foundType != undefined;
        }
        
        let project_typeOption = { type: project_type.id, name: project_type.name, project_type: project_type, selected: selected };
        return project_typeOption;
      });
    }

    project_typesList.unshift({ type: -1, name: '-- All Types --', all: true });
    let projectManagersList=null;
    if(this.state.projectManagers){
      projectManagersList=this.state.projectManagers.filter(function(user){
        return !user.suspended;
      });  
    }
   
    let project_typeSelector = (
      <ComboBox 
        id={'project_typePicker'}
        options={project_typesList}
        multiSelect={true} 
        hasBorder={false}
        underlined={false}
        backgroundIndex={27}
        height={32}
        width={isVertical ? 304 : 230}
        displayFontStyle={{ fontSize: '12px' }}
        handleMultiMenuSelection={this.handleProjectTypeChange}
        placeHolderText={this.textMap.projectType}
      />
    );

    let projectManagerSelector =
      <SelectUserComboBox 
        key="project_managerPicker"  
        hasBorder={false} 
        multiSelect={true} 
        height={32}  
        width={isVertical ? 304 : 230}
        selectedUsers={selectedProjectManagers ? selectedProjectManagers : []} 
        backgroundIndex={27}
        menuUp={false} 
        menuBelow={true} 
        handleMultipleSelection={this.handleProjectManagerSelection} 
        displayFontStyle={{ fontSize: '12px' }} 
        useMultiTab={false}
        users={projectManagersList}  
      />;

    let className = altClassName ? altClassName : 'CloseoutReportFilters';
    className += isVertical ? ' ' + className + '--vertical' : '';
    
    let closeoutusersList=null;
    if(this.state.closeoutUsers){
      closeoutusersList=this.state.closeoutUsers.filter(function(user){
        return !user.suspended;
      });  
    }
    let closeoutUserSelector =
      <SelectUserComboBox 
        key="closeout_userPicker"  
        hasBorder={false} 
        multiSelect={true} 
        height={32}  
        width={isVertical ? 304 : 230}
        selectedUsers={selectedCloseoutUsers ? selectedCloseoutUsers : []} 
        backgroundIndex={27}
        menuUp={false} 
        menuBelow={true} 
        handleMultipleSelection={this.handleCloseoutUserSelection} 
        displayFontStyle={{ fontSize: '12px' }} 
        useMultiTab={false}
        users={closeoutusersList}  
      />;

    return (
      <div className={className}>
        <div className={'closeout-filter-container closeout-filter-container__project-types'}>
          <div className='closeout-filter-selector-label'>
            {this.textMap.projectType.toUpperCase()}
          </div>
          <div className='closeout-filter-selector-container'>
            {project_typeSelector}
          </div>
          <div className='closeout-filter-selector-filtertags'>
            <FilterTags filters={selectedProjectTypes} handleFilterRemoved={this.handleProjectTypeFilterRemoved} isDashboard={this.props.isDashboard}/>
          </div>
        </div>
        {statusSelector}
        {typeSelector}
        <div className={'closeout-filter-container closeout-filter-container__project-managers'}>
          <div className='closeout-filter-selector-label'>
            {'PROJECT MANAGERS'}
          </div>
          <div className='closeout-filter-selector-container'>
            {projectManagerSelector}
          </div>
          <div className='closeout-filter-selector-filtertags'>
            <FilterTags filters={selectedProjectManagers} handleFilterRemoved={this.handleProjectManagerFilterRemoved} isDashboard={this.props.isDashboard}/>
          </div>
        </div>
        <div className={'closeout-filter-container closeout-filter-container__closeout-users'}>
          <div className='closeout-filter-selector-label'>
            {'GENERATED BY'}
          </div>
          <div className='closeout-filter-selector-container'>
            {closeoutUserSelector}
          </div>
          <div className='closeout-filter-selector-filtertags'>
            <FilterTags filters={selectedCloseoutUsers} handleFilterRemoved={this.handleCloseoutUserFilterRemoved} isDashboard={this.props.isDashboard}/>
          </div>
        </div>
          <div 
            className={'closeout-filter-container'} 
            onClick={this.handleDateDisplay}
          >
            <div className="closeout-filter-selector-label">{'DATE GENERATED'}</div>
            <div
              className='closeout-filter-selector-container closeout-filter-selector-container__time-frame'
              ref={el => { this.projectFilterContainer = el; }}
            >
              <p className='closeout-filter-all-time'>
                { this.createTimeDisplay() }
              </p>
              <img className='time-caret' src={caret} role="presentation"/>
            </div>
            <div className='closeout-filter-selector-filtertags'>
              <FilterTags filters={dateFilterTags} handleFilterRemoved={this.handleDateFilterRemoved} isDashboard={this.props.isDashboard}/>
            </div>
          </div>
        <div ref={el => {this.reportDatePicker = el;}} >
          <ReportDatePicker
            handleSetDatePickerRef={this.handleSetDatePickerRef}
            handleDateSelection={this.handleDateSelection}
            displayRadioButtons={true}
            left={this.state.datePickerLeft}
            top={this.state.datePickerTop}
            startDate={this.state.startDate}
            endDate={this.state.endDate}
          />
        </div>
     </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ProjectSummaryContainer/CloseoutSummary/CloseoutReportFilters/index.js